import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  alt: {
    id: 'studio.+kMIBF',
    defaultMessage: 'Icon for {appName}',
  },
});
